"use client";

import { createRestDataProviderClient } from "@providers/data-provider/rest-data-provider.client";
import { HighlightedText } from "@shared/ui";
import { transformQueryParamsWithoutLocale } from "@shared/utils";
import { Skeleton } from "@ubud-ui/react-ui-kit";
import { useQuery } from "@tanstack/react-query";
import Link from "next/link";

type Skill = {
  id: string;
  name: string;
};

export function SkillResult({ keyword, onClick }: { keyword: string; onClick: () => void }) {
  const restDataProviderClient = createRestDataProviderClient();

  const { data: result, isFetching } = useQuery<{ data: Skill[] }>({
    queryKey: ["header-search-skills", keyword],
    queryFn: () =>
      restDataProviderClient.custom({
        url: transformQueryParamsWithoutLocale("/karirhub/v2/skills", {
          limit: 5,
          keyword: keyword,
        }),
        method: "GET",
      }),
    enabled: !!keyword,
  });

  const getFilter = (skill: Skill) => {
    return transformQueryParamsWithoutLocale("/lowongan-dalam-negeri/lowongan", {
      skills: [
        {
          id: skill.id,
          label: skill.name,
        },
      ],
    });
  };

  if (isFetching) {
    return (
      <div>
        <h4 className="p-3 font-bold text-lg">Lowongan kerja berdasarkan keahlian</h4>
        <div className="space-y-2 mt-1">
          {[1, 2, 3, 4, 5].map((it) => {
            return (
              <div className="rounded-lg relative h-10 overflow-hidden" key={it}>
                <Skeleton className="absolute w-full h-full bg-gray-200" />
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  if (result && result.data?.length <= 0) {
    return <></>;
  }

  return (
    <div>
      <h4 className="p-3 font-bold text-lg">Lowongan kerja berdasarkan keahlian</h4>
      <div>
        {result?.data?.map((item) => {
          return (
            <Link
              key={item.id}
              href={getFilter(item)}
              className="flex items-start hover:bg-gray-200 rounded-lg p-3 gap-2"
              onClick={onClick}
            >
              <span className="font-semibold">
                <HighlightedText keyword={keyword} text={item.name} />
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
